import { render } from "./BlockMovie.vue?vue&type=template&id=305061fa&scoped=true"
import script from "./BlockMovie.vue?vue&type=script&lang=js"
export * from "./BlockMovie.vue?vue&type=script&lang=js"

import "./BlockMovie.vue?vue&type=style&index=0&id=305061fa&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305061fa"]])

export default __exports__